module.exports = __webpack_public_path__ + "img/ios-alert.80af9b4a.svg";